import { useContext } from "react";
import { UserPreferencesContext } from "../contexts/UserPreferencesContext";

const useLocale = () => {
	const context = useContext(UserPreferencesContext);
	if (!context) {
		throw new Error("useLocale must be used within a UserPreferencesProvider");
	}

	const { locale, setLocale } = context;

	return { locale, setLocale };
};

export default useLocale;
